import { render } from "./PreLoader.vue?vue&type=template&id=0b5ca77c&ts=true"
import script from "./PreLoader.vue?vue&type=script&lang=ts"
export * from "./PreLoader.vue?vue&type=script&lang=ts"

import "./PreLoader.vue?vue&type=style&index=0&id=0b5ca77c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__